import React from 'react';
import PropTypes from 'prop-types';
import './Avatar.scss';

function Avatar(props) {
    const { image, title, role } = props;
    return (
        <div className="avatar-container">
            <img src={image} alt="avatar" />
            {title && (
                <div className="title">
                    {`${title}`}
                </div>
            )}
            {role && (
                <div className="title" style={{ textTransform: 'capitalize' }}>
                    {`${role}`}
                </div>
            )}
        </div>
    );
}

Avatar.propTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string,
    role: PropTypes.string,
};

Avatar.defaultProps = {
    title: null,
    role: null,
};

export default Avatar;
